import { useEffect, useRef } from 'react';

export function useDragResize(onDrag: (newWidth: number) => void) {
  const isResized = useRef(false);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!isResized.current) {
        return;
      }
      onDrag(window.innerWidth - e.x);
    };

    const handleMouseUp = () => {
      isResized.current = false;
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [onDrag]);

  const handleMouseDown = () => {
    isResized.current = true;
  };

  return { handleMouseDown };
}
